module.exports = __webpack_public_path__ + "media/img/star-5000254d328af6822042ebbe7b1eaa88.gif";